// extracted by mini-css-extract-plugin
export var quillEditor = "_ho-1";
export var variable = "_ho-0";